import { IPartialTheme, IStyleSet } from "@fluentui/react/lib/Styling"
import { IStyleFunctionOrObject } from "@fluentui/react/lib/Utilities"

import { IHeaderMenuStyles } from "./HeaderMenu.types"

export const HeaderMenuStyles: IStyleFunctionOrObject<
    IPartialTheme,
    IStyleSet<IHeaderMenuStyles>
> = (theme: IPartialTheme) => ({
    button: {
        border: "none",
        borderRadius: "0em",
        backgroundColor: "transparent",
        padding: "0.3em",
        minWidth: 0,
        height: "auto",
        fontSize: 20,
        selectors: {
            ":hover": {
                backgroundColor: theme.palette?.themeLighter,
                color: theme.palette?.themePrimary
            },
            ":active": {
                backgroundColor: theme.palette?.themeLighter,
                color: theme.palette?.themePrimary
            },
            ":focus&::after": {
                outlineColor: theme.semanticColors?.focusBorder
            },
            i: {
                color: "inherit",
                fontSize: "inherit",
                height: "auto",
                lineHeight: "normal",
                margin: 0
            }
        }
    },

    menuOpen: {
        backgroundColor: theme.palette?.themeLighter,
        color: theme.palette?.themePrimary
    }
})
